import classes from './TabSelector.module.css';

export const TabSelector = ({
  isActive,
  children,
  onClick,
}: {
  isActive: boolean;
  children: React.ReactNode;
  onClick: () => void;
}) => (
  <button
    className={`${isActive ? classes.active : classes.inactive}`}
    onClick={onClick}
  >
    {children}
  </button>
);